import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";
import SectionLabel from "./SectionLabel";

export default function FAQ() {
  const { t } = useI18n();
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="relative py-20 md:py-32 border-t border-line">
      <div className="container-px mx-auto max-w-4xl">
        <SectionLabel>{t.faq.label}</SectionLabel>
        <h2 className="mt-6 font-display font-bold text-ink text-balance leading-[1.05]
                       text-3xl sm:text-5xl lg:text-6xl">
          {t.faq.title}
        </h2>

        <div className="mt-12 hairline rounded-2xl overflow-hidden" data-testid="faq-list">
          {t.faq.items.map((it, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className={`${i > 0 ? "border-t" : ""}`} style={{ borderColor: "rgba(245,247,250,0.08)" }}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-6 px-5 md:px-7 py-5 text-left group"
                  aria-expanded={isOpen}
                  data-testid={`faq-question-${i}`}
                >
                  <span className="font-display text-ink text-base md:text-lg font-semibold group-hover:neon-text transition-colors">
                    {it.q}
                  </span>
                  <span className="grid h-7 w-7 place-items-center rounded-md hairline flex-shrink-0 transition-colors"
                        style={{
                          background: isOpen ? "rgba(0,255,136,0.10)" : "transparent",
                          borderColor: isOpen ? "rgba(0,255,136,0.4)" : "rgba(245,247,250,0.08)",
                        }}>
                    {isOpen ? <Minus size={14} color="#00FF88" /> : <Plus size={14} color="#F5F7FA" />}
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      key="content"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                      data-testid={`faq-answer-${i}`}
                    >
                      <p className="px-5 md:px-7 pb-6 text-ink/70 text-[15px] leading-relaxed max-w-3xl">
                        {it.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
